<ng-container *ngIf="formGroup">
    <div [formGroup]="formGroup" class="employment-history-form mb-5">
        <h4>{{ title ? title : 'Current Employment' }}</h4>
        <div class="row mb-4">
            <div class="col">
                <app-form-input label="Company Name" [formControl]="formGroup.controls.name"></app-form-input>
            </div>

            <div class="col">
                <app-form-input label="Position" [formControl]="formGroup.controls.position"></app-form-input>
            </div>
        </div>
        <div class="row mb-4">
            <div class="col">
                <app-form-datepicker
                    label="Start Date"
                    [formControl]="formGroup.controls.startDate"
                ></app-form-datepicker>
            </div>

            <div *ngIf="!formGroup.controls.endDate.disabled" class="col">
                <app-form-datepicker
                    label="End Date"
                    [formControl]="formGroup.controls.endDate"
                ></app-form-datepicker>
            </div>

            <div *ngIf="!formGroup.controls.isCurrent.disabled" class="col">
                <app-form-checkbox
                    label="I currently work here"
                    [formControl]="formGroup.controls.isCurrent"
                ></app-form-checkbox>
            </div>
        </div>

        <app-forms-address
            *ngIf="address"
            [title]="addressTitle ? addressTitle : 'Company Address'"
            [formGroup]="address"></app-forms-address>
    </div>
</ng-container>
